const MAX_LABEL_LEVEL = 7

const responseFunc = response => {
  const { data, config } = response

  // 标签层级补偿
  const baseUrl = config.baseURL ? config.baseURL : ''
  const key = baseUrl.replace(process.env.VUE_APP_APIBASEURL, '') + config.url
  if (['/api/v1/xreports/cem/dataCube/detailQuery', '/api/v1/xreports/cem/dataCube/group/detailQuery'].includes(key)) {
    const records = data?.data?.records || []
    for (const item of records) {
      const cubeCommentLabelList = item?.extraValues?.cubeCommentLabelList || []
      for (const obj of cubeCommentLabelList) {
        let maxLevel = 0
        for (let i = MAX_LABEL_LEVEL; i > 0; i--) {
          if (obj.labelMap[`label${i}`]) {
            maxLevel = i
          }
          if (i < maxLevel) {
            obj.labelMap[`label${i}`] = obj.labelMap[`label${i}`] || null
          }
        }
      }
    }
  }

  return response
}

const responseError = error => {
  return Promise.reject(error)
}
// 添加响应拦截器
axios.interceptors.response.use(responseFunc, responseError)
